const HoverItemsObj = {
    el: null,
    items: {},
    currentId: null,
    previousId: -1
}

export function HoverItems() {
    const Els = document.querySelectorAll('.js-hover-items')
    Array.from(Els).forEach(createHoverItems)
}

function createHoverItems(el) {
    const Obj = Object.assign({}, HoverItemsObj)
    init.call(Obj, el)
}

function init(el) {
    if (!el) {
        return
    }

    this.el = el
    this.items = this.el.querySelectorAll('[data-hover-item]')
    this.currentId = this.items[0].dataset.hoverItem
    this.items = Array.from(this.items).reduce((acc, el) => {
        acc[el.dataset.hoverItem] = el
        return acc
    }, {})

    this.el.addEventListener('mouseover', handleClick.bind(this))
    this.el.addEventListener('focusin', handleClick.bind(this))
}

function handleClick(evt) {
    if (!evt.target.dataset.hoverBtn) {
        return
    }

    const id = evt.target.dataset.hoverBtn
    if (id === this.currentId) {
        return
    }

    if (~this.previousId) {
        this.items[this.previousId].classList.remove('is-previous')
    }

    this.items[this.currentId].classList.remove('is-active')
    this.items[this.currentId].classList.add('is-previous')
    this.previousId = this.currentId

    this.items[id].classList.add('is-active')
    this.currentId = id
}
